<template>
  <div class="container">
    <CommonTitle :titleName="'报名'" bcColor="#f7f8fc" />

    <div class="two_top">
      <img
        class="two_area_icon"
        src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/mockSignLs/mock_sign_area.png"
        alt
      />
      <div class="two_area_text">{{areaSelectedStr}}</div>
    </div>
    <div class="list">
      <div class="item" v-for="item in dataSource" :key="item.examCenterName">
        <div class="item_name">{{item.examCenterName}}</div>
        <div
          :class="{item_btn: true, item_btn_disable: item.quota == 0 && item.switchStatus === '关' }"
          @click="onSign(item)"
        >报名</div>
        <div class="item_num" v-if="item.quota && item.quota != '0' ">余{{item.quota}}</div>
      </div>
    </div>
    <div class="shadow" v-show="showModal">
      <div class="modal_box">
        <div class="text1">请拨打电话完成报名（仅支持电话报名）</div>
        <!-- <div class="text2" @click="onCall">{{phone}}</div> -->
        <!-- <input type="phone" class="text2" :value="phone" @click="onCall" /> -->
        <a :href="`tel:${phone}`" class="text2" @click="onCall">{{phone}}</a>
        <div class="line"></div>
        <div class="cancel" @click="showModal = false">取消</div>
      </div>
    </div>
  </div>
</template>

<script>
import CommonTitle from '@/components/header/CommonTitle.vue';
import { postRegisTrationList } from '@/api/registration/index';

export default {
  components: {
    CommonTitle,
  },

  data() {
    return {
      id: null,
      areaStr: '',
      selectedArea: {
        province: '',
        city: '',
        district: '',
      },
      showModal: false,
      dataSource: [],
      phone: '',
      timer: null,
    };
  },

  methods: {
    onSign(item) {
      const { id, quota, switchStatus, phone } = item;
      if (quota > 0 || switchStatus === '开') {
        this.showModal = true;
        this.phone = phone;
        this.id = id;
      }
    },

    onCall() {
      console.log('onCall');
      if (this.timer) {
        return;
      }
      this.timer = setTimeout(() => {
        postRegisTrationList(this.id).then(res => {});
        clearTimeout(this.timer);
        this.timer = null;
      }, 600);
    },
  },

  mounted() {
    const data = sessionStorage.getItem('REGISTRATION_DISTRICTLIST');
    const dataSource = JSON.parse(data);
    const { province = '', city = '', district = '' } = dataSource[0];

    this.dataSource = dataSource;
    this.selectedArea = {
      province,
      city,
      district,
    };
  },
  computed: {
    areaSelectedStr() {
      return `${this.selectedArea.province}${this.selectedArea.city}${this.selectedArea.district}`;
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .van-overlay {
  z-index: 10001 !important;
}
.container {
  height: 100vh;
  width: 100%;
  overflow: hidden;
  padding: 232px 36px 0;
  background: #f7f8fc;
  font-family: PingFangSC, PingFang SC;

  .two_top {
    display: flex;
    align-items: center;

    .two_area_icon {
      height: 51px;
      width: 51px;
      display: block;
    }
    .two_area_text {
      height: 40px;
      font-weight: 500;
      font-size: 29px;
      color: #333333;
      line-height: 40px;
      margin-left: 14px;
    }
  }

  .list {
    width: 678px;
    margin-top: 58px;

    .item {
      position: relative;
      width: 678px;
      height: 145px;
      background: #ffffff;
      border-radius: 14px;
      margin-bottom: 22px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 29px 0;

      .item_name {
        position: relative;
        font-weight: 500;
        font-size: 25px;
        color: #333333;
        line-height: 36px;
        font-style: normal;
        text-align: left;
        width: 458px;
      }
      .item_btn {
        width: 127px;
        height: 58px;
        background: #ff7f41;
        border-radius: 29px;
        font-weight: 500;
        font-size: 25px;
        color: #ffffff;
        line-height: 58px;
        text-align: center;
      }

      .item_btn_disable {
        opacity: 0.3;
      }

      .item_num {
        position: absolute;
        width: 69px;
        height: 33px;
        background: #ffd759;
        border-radius: 0px 14px 0px 14px;
        top: 0;
        right: 0;

        font-weight: 500;
        font-size: 18px;
        color: #7c2e00;
        line-height: 33px;
        text-align: center;
      }
    }
  }

  .shadow {
    position: fixed;
    z-index: 10001;
    height: 100vh;
    width: 100%;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.6);

    .modal_box {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 750px;
      height: 388px;
      background: #ffffff;
      border-radius: 36px 36px 0px 0px;

      .text1 {
        height: 40px;
        width: 100%;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 29px;
        color: #333333;
        line-height: 40px;
        text-align: center;
        margin-top: 54px;
      }

      .text2 {
        display: block;
        height: 40px;
        width: 100%;

        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 29px;
        color: #3e85ff;
        line-height: 40px;
        text-align: center;
        margin-top: 36px;
      }

      .line {
        width: 750px;
        height: 22px;
        background: #f7f8fc;
        margin-top: 36px;
      }

      .cancel {
        height: 40px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 29px;
        color: #333333;
        text-align: center;
        line-height: 40px;
        margin-top: 29px;
      }
    }
  }
}
</style>